export default "__VITE_PUBLIC_ASSET__0997057b__"